import DropdownWithTextToggle from 'components/DropdownWithTextToggle';
import { useContextLayout } from 'components/Layout/context';
import { BaseDataList } from 'constants/base-data-list';
import React, { useEffect, useState } from 'react';

// Future feature (More base data elements)
// const categories: string[] = Object.values(BaseDataList);
const categories: string[] = [
  BaseDataList.RESIDENTS.valueOf(),
  BaseDataList.EMPLOYEES.valueOf(),
  BaseDataList.DOCTORS.valueOf(),
  BaseDataList.INSURANCE.valueOf(),
  BaseDataList.WELFARE_OFFICES.valueOf(),
];

type SelectProps = { onSelect: (e: string | null) => void };

const CategorySelect = ({ onSelect }: SelectProps) => {
  const { baseDataListSelected } = useContextLayout();
  const [initialOptionIndex, setInitialOptionIndex] = useState(0);

  useEffect(() => {
    switch (baseDataListSelected) {
      case BaseDataList.RESIDENTS:
        setInitialOptionIndex(0);
        break;
      case BaseDataList.EMPLOYEES:
        setInitialOptionIndex(1);
        break;
      case BaseDataList.DOCTORS:
        setInitialOptionIndex(2);
        break;
      case BaseDataList.INSURANCE:
        setInitialOptionIndex(3);
        break;
      case BaseDataList.WELFARE_OFFICES:
        setInitialOptionIndex(4);
        break;
      // Future feature (More base data elements)
      // case BaseDataList.CONTACTS:
      //   setInitialOptionIndex(3);
      //   break;
      // case BaseDataList.ACCOUNTS:
      //   setInitialOptionIndex(4);
      //   break;
      // case BaseDataList.SUPERVISORS:
      //   setInitialOptionIndex(5);
      // break;
      default:
        setInitialOptionIndex(0);
    }
  }, [baseDataListSelected]);

  return (
    <DropdownWithTextToggle
      options={categories}
      onSelect={onSelect}
      initialOptionIndex={initialOptionIndex}
    />
  );
};

export default CategorySelect;
